import axios from 'axios'
import { BUSCAR_SE_USUARIO_BLOQUEADO_EDICAO_E_REIMPRESAO_CUPOM } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function buscarSeUsuarioBloqueadoEdicaoReimpressaoCupom (codigo) {
  const url = `${URL}/usuarios-empresa/empresa/${codigo}/bloqueio-edicao-reimpressao-cupom`;

  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: BUSCAR_SE_USUARIO_BLOQUEADO_EDICAO_E_REIMPRESAO_CUPOM,
        payload: response

      })
  );
}
